import React from 'react';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input, InputNumber, Switch } from 'antd';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'title', label: 'Title', required: true },
];

export const LevelEdit: React.FC = () => {
  const { formProps, saveButtonProps, queryResult } = useForm({ resource: 'levels' });

  return (
    <Edit resource="levels" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS, queryResult?.data?.data?.translations),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Level Number" name="levelNumber" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item label="Required XP" name="requiredXp" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Reward Coins" name="rewardCoins">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Reward Badge ID" name="rewardBadgeId">
          <Input placeholder="Optional badge ID awarded on level-up" />
        </Form.Item>
        <Form.Item label="Icon URL" name="iconUrl">
          <Input />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
